import { App } from 'vue'
import Theme from './LpTheme.vue'

Theme.install = (Vue: App) => {
  Vue.component(Theme.name, Theme)
}

export default Theme
